import ShowInformation from "./ShowInformation";
import Create from "./Create";
import Update from "./Update";
import Body from "./Body";
import Search from "./Search";
import Filter from "./Filter";
import RemoveIsArchive from "./RemoveIsArchive";

const Components = {
  ShowInformation,
  RemoveIsArchive,
  Create,
  Update,
  Body,
  Search,
  Filter,
};

export default Components;
